import React, { Component } from "react";
import Countdown from "../components/CountDown";
import Loading from "../components/Loading";
import {
  ScrollView,
  View,
  StyleSheet,
  TouchableHighlight,
  Platform,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import { translate } from "../locales/translate";

import ArButton from "../argon-ui/Button";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  // faPlus,
  faUserCog,
  faUserTimes,
  faUsers,
  faEllipsisV,
  faArrowLeft,
  faUser,
  faSlidersH,
  faArrowRight,
  // faPhoneAlt,
} from "../../assets/consts/faCharCodes";
import Theme from "../argon-ui/Theme";
import * as Actions from "../actions/UserActions";
import InputSearch from "../components_v2/InputSearch";
import MessageBox from "../components_v2/MessageBox";
// import TabBase from "../nativeBase-ui/TabBase";
import { Checkbox, Collapse, HStack, IconButton } from "native-base";
import { hidePhoneNumber } from "../hooks/hidePhoneNumber";
import { Menu, MenuItem } from "react-native-material-menu";
import ModalBase from "../nativeBase-ui/ModalBase";
import { ROLE_NONE } from "../actions/roleHelper";
import { getDir, getIsRTL } from "../util";
const IS_WEB = Platform.OS == "web";
class UserListScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      accessToken: "",
      selectedTab: "allUsers", // allUsers | guests
      searchQuery: "",
      showInviteUserModal: true,
      invitePhoneNumber: "",
      isLoadingInviteUser: false,
      serverUrl: null,
      openFilterCollapse: false,
      filterUsers: [],
    };
    // this.toastRef = undefined;
    this.tabs = ["allUsers", "guests"];
    this.filterUsersList = [
      {
        label: translate("user.usersWithoutAccess"),
        value: "none",
      },
    ];
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.UserList"),
  });
  componentDidMount() {
    let searchTerm = "";
    let { accessToken, publicAddress } = this.props.appReducer?.currentServer;
    this.props.getAll(searchTerm, accessToken);
    this.setState({
      accessToken,
      isLoading: false,
      serverUrl: this.props.appReducer.serverUrl,
    });
  }
  // static getDerivedStateFromProps(nextProps, prevState) {
  //   if (nextProps.reducer.removeUserError) {
  //     this.showToast(translate("user.removeError"));
  //     this.props.RemoveErrorLocally();
  //   }
  //   return null;
  // }
  // onAddButtonPress = () => {
  //   this.props.navigation.navigate("AddUser");
  // };
  // showToast = (msg) => {
  //   this.toastRef.show(msg, 2000);
  // };

  handleNavigateToAccessList = (u = null) => {
    if (u) {
      let { id, expireDate } = u;
      this.props.navigation.navigate("UserAccess", {
        userId: id,
        expireDate: expireDate, // will use to check users list or guests list
      });
    }
  };

  handleTabChange = (tab) => {
    this.setState({
      selectedTab: tab,
    });
  };
  showInviteUserModal = () => {
    this.setState({ showInviteUserModal: true });
  };
  hideInviteUserModal = () => {
    this.setState({ showInviteUserModal: false });
  };
  toggleFilterCollapse = () => {
    this.setState({ openFilterCollapse: !this.state.openFilterCollapse });
  };
  // === filter user ===
  filterUserHandler = (value) => {
    console.log("value", value);
    let filterList = this.state.filterUsers;
    if (filterList.includes((i) => i === value)) {
      filterList = filterList.filter((i) => i !== value);
    } else {
      filterList.push(value);
    }
    console.log("filterList", filterList);
  };
  // inviteUser = () => {
  //   var isValid = true;
  //   const phoneNumber = this.state.invitePhoneNumber;
  //   var _serverUrl = this.state.serverUrl;
  //   if (phoneNumber === "") {
  //     isValid = false;
  //   }

  //   if (isValid && _serverUrl) {
  //     if (!_serverUrl.endsWith("/")) {
  //       _serverUrl = _serverUrl + "/";
  //     }
  //     this.setState({ isLoadingInviteUser: true });
  //     fetch(`${this.state.serverUrl}Users/Add`, {
  //       method: "post",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${this.state.accessToken}`,
  //       },
  //       body: JSON.stringify({
  //         UserName: phoneNumber,
  //         Description: "",
  //         role: this.state.role,
  //         expireValue: this.state.expireValue,
  //         expireUnit: this.state.expireUnit,
  //         buildingId: this.props.appReducer.currentBuilding.buildingId,
  //       }),
  //     })
  //       .then((res) => {
  //         return res.json();
  //       })
  //       .then((resJ) => {
  //         if (resJ.succeeded) {
  //           let {
  //             createdPhoneNumber,
  //             token,
  //             role,
  //             hasPublicAddress,
  //             userId,
  //             registerCompleted,
  //             fullName,
  //           } = resJ;
  //           registerCompleted = registerCompleted || false;
  //           let qrData = { createdPhoneNumber, token };
  //           this.setState({
  //             qrDataString: JSON.stringify(qrData),
  //             view: registerCompleted ? "form" : "QR",
  //             isLoading: false,
  //             hasPublicAddress: hasPublicAddress || false,
  //             userId,
  //             fullName,
  //             registerCompleted: registerCompleted || false,
  //           });
  //         } else {
  //           this.setState({
  //             serverAuthErrors: resJ.errors || [],
  //             isLoadingInviteUser: false,
  //           });
  //         }
  //       })
  //       .catch(console.log);
  //   }
  // };
  render() {
    var memberUsers = this.props.reducer.users.filter((u) =>
      this.state.filterUsers.length !== 0
        ? this.state.filterUsers.includes(u.topLevel)
        : true
    );
    // var guestUsers = this.props.reducer.users.filter(
    //   (u) => u.expireDate != null
    // );
    if (this.state.isLoading || this.props.reducer.isLoading) {
      return <Loading message={translate("splash.fetchingData")} />;
    } else {
      let tmpUsers = [];
      tmpUsers = memberUsers;
      // if (this.state.selectedTab == "allUsers") {
      // } else if (this.state.selectedTab == "guests") {
      //   tmpUsers = guestUsers;
      // }
      return (
        <View style={styles.container}>
          <HStack alignItems="center">
            <InputSearch
              searchContainer={{ flex: 1, padding: 0 }}
              placeholder={`${translate("app.search")} (${translate(
                "login.fullName"
              )}/${translate("login.phoneNumber")})`}
              value={this.state.searchQuery}
              onChangeText={(txt) => {
                this.setState({ searchQuery: txt });
              }}
            />
            <IconButton
              colorScheme="gray"
              variant="ghost"
              style={{
                marginHorizontal: 5,
                borderRadius: 10,
                backgroundColor: Theme.COLORS.PRIMARY + "15",
                shadowColor: Theme.COLORS.INPUT,
                shadowOffset: {
                  width: 0,
                  height: 6,
                },
                shadowOpacity: 0.3,
                shadowRadius: 6.65,
                elevation: 9,
              }}
              w="40px"
              h="40px"
              onPress={this.toggleFilterCollapse}
              icon={
                <FontAwesomeIcon
                  icon={faSlidersH}
                  size={16}
                  color={Theme.COLORS.PRIMARY}
                />
              }
            />
          </HStack>

          <Collapse
            duration={300}
            isOpen={this.state.openFilterCollapse}
            style={{ padding: 5 }}
          >
            <View
              style={{
                backgroundColor: Theme.COLORS.WHITE,
                padding: 10,
                borderRadius: 10,
              }}
            >
              {/* === filter users === */}
              <Checkbox.Group
                onChange={(v) => {
                  this.setState({ filterUsers: v });
                }}
                value={this.state.filterUsers}
                accessibilityLabel="choose numbers"
              >
                {this.filterUsersList.map((i, index) => {
                  return (
                    <Checkbox
                      size="sm"
                      value={i.value}
                      my={2}
                      key={index}
                      _text={{ fontSize: 12 }}
                    >
                      {i.label}
                    </Checkbox>
                  );
                })}
              </Checkbox.Group>
              {/* <TabBase
              tab={this.state.selectedTab}
              tabs={this.tabs}
              handleChange={(tab) => this.handleTabChange(tab)}
            /> */}
            </View>
          </Collapse>

          {/* <Text style={styles.heading}>{this.state.selectedTab == 'all' ? translate("user.allUsers") : this.state.selectedTab == 'new' ? translate("user.guests") : ''}</Text> */}
          <ScrollView
            showsVerticalScrollIndicator={false}
            style={{
              paddingBottom: 5,
              paddingHorizontal: 5,
            }}
          >
            {tmpUsers.length == 0 ? (
              <View style={{ paddingHorizontal: 10 }}>
                <MessageBox icon={faUsers}>
                  {translate("app.emptyList")}
                </MessageBox>
              </View>
            ) : (
              tmpUsers
                .filter((u) => {
                  return (
                    !this.state.searchQuery ||
                    (u.fullName &&
                      u.fullName.indexOf(this.state.searchQuery) >= 0) ||
                    (u.phoneNumber &&
                      u.phoneNumber.indexOf(this.state.searchQuery) >= 0) ||
                    (u.phoneNumber &&
                      ("0" + u.phoneNumber).indexOf(this.state.searchQuery) >=
                        0)
                  );
                })
                .sort((a, b) => {
                  return a.fullName > b.fullName ? 1 : -1;
                })
                .map((u) => {
                  return (
                    <UserListItem
                      key={u.id}
                      model={u}
                      handleNavigateToAccessList={() =>
                        this.handleNavigateToAccessList(u)
                      }
                      removeUser={(userId) =>
                        this.props.RemoveUser(userId, this.state.accessToken)
                      }
                    />
                  );
                })
            )}
          </ScrollView>
          {/* <TouchableHighlight
            style={styles.btnAdd}
            onPress={this.onAddButtonPress}
          >
            <FontAwesomeIcon icon={faPlus} size={30} color="#FFF" />
          </TouchableHighlight> */}
          {/* === invite User === */}
          {/* <ModalBase
            header={translate("user.inviteUser")}
            isOpen={this.state.showInviteUserModal}
            onClose={() => this.hideInviteUserModal()}
          >
            <View style={{ padding: 10 }}>
              <Text
                style={{
                  fontSize: 14,
                  color: Theme.COLORS.MUTED,
                  marginBottom: 10,
                }}
              >
                {translate("user.inviteUserDesc")}
              </Text>
              <InputBase
                icon={faPhoneAlt}
                inputStyle={{ height: 50 }}
                showSubInput={true}
                placeholder={translate("login.phoneNumber")}
                keyboardType="numeric"
                // isInvalid={formValidityData.phoneNumberError}
                // errorMessage={formValidityData.phoneNumberErrorMessage}
                value={this.state.invitePhoneNumber}
                onChangeText={(phoneNumber) =>
                  this.setState({ invitePhoneNumber: phoneNumber })
                }
                // onSubmitEditing={() => {
                //   if (formData.phoneNumber.length > 9) {
                //     setFormValidityData({
                //       type: "VALIDATE_PHONE_NUMBER",
                //       payLoad: formData,
                //     });
                //     handleValidationFunction();
                //   }
                // }}
              />
            </View>
          </ModalBase> */}
        </View>
      );
    }
  }
}

class UserListItem extends Component {
  constructor(props) {
    super(props);
    // console.log("UserListItem.model in ctor()", this.props.model);
    let expireSeconds = this.calculateExpireSeconds();

    this.state = {
      expireSeconds,
      showDeleteModal: false,
      menuVisible: false,
    };
  }
  UNSAFE_componentWillReceiveProps() {
    let expireSeconds = this.calculateExpireSeconds();

    if (Math.abs(this.state.expireSeconds - expireSeconds) > 60) {
      this.setState({ expireSeconds });
    }
  }

  calculateExpireSeconds = () => {
    let expireSeconds = 0;
    if (this.props.model.expireDate) {
      var exp = new Date(this.props.model.expireDate);
      var now = new Date();

      var currentLocalDate = Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        now.getHours(),
        now.getMinutes(),
        now.getSeconds()
      );

      expireSeconds = (exp.getTime() - currentLocalDate) / 1000;
    }
    return expireSeconds;
  };

  // === delete handler ===
  hideDeleteModal = () => {
    this.setState({ showDeleteModal: false });
  };
  showDeleteModal = () => {
    this.setState({ showDeleteModal: true });
  };
  handleDeleteUser = (userId) => {
    this.props.removeUser(userId);
    this.hideDeleteModal();
  };

  hideMenu = () => this.setState({ menuVisible: false });
  showMenu = () => this.setState({ menuVisible: true });
  render() {
    // console.log("this.props.model in userListItem.render()", this.props.model);
    return (
      <>
        <TouchableHighlight
          underlayColor="transparent"
          style={styles.userItemsWrapper}
          onPress={() => this.props.handleNavigateToAccessList()}
        >
          <HStack alignItems="center" space="2" px="2">
            {/* === menu === */}
            <View style={{ direction: "rtl", paddingVertical: 3 }}>
              <IconButton
                h="full"
                colorScheme="muted"
                variant="ghost"
                onPress={() => {
                  this.showMenu();
                }}
                icon={
                  <FontAwesomeIcon
                    icon={faEllipsisV}
                    size={16}
                    color={Theme.COLORS.MUTED}
                  />
                }
              />
              {this.state.menuVisible && (
                <Menu
                  visible={this.state.menuVisible}
                  onRequestClose={this.hideMenu}
                  style={styles.menuShadow}
                >
                  {/* === userAccess === */}
                  <MenuItem
                    onPress={() => {
                      this.hideMenu();
                      this.props.handleNavigateToAccessList();
                    }}
                  >
                    <RenderMenuItem icon={faUserCog}>
                      {translate("user.manageUserAccess")}
                    </RenderMenuItem>
                  </MenuItem>
                  {/* === delete handler == */}
                  <MenuItem
                    onPress={() => {
                      this.hideMenu();
                      this.showDeleteModal();
                    }}
                  >
                    <RenderMenuItem icon={faUserTimes}>
                      {translate("user.deleteUser")}
                    </RenderMenuItem>
                  </MenuItem>
                </Menu>
              )}
            </View>
            <View
              style={[
                styles.iconRoleContainer,
                {
                  backgroundColor: Theme.COLORS.LIGHT_MAIN,
                },
              ]}
            >
              <FontAwesomeIcon
                icon={faUser}
                size={16}
                style={{ marginVertical: 5 }}
                color={Theme.COLORS.MUTED}
              />
            </View>
            <HStack flex={1} justifyContent="space-between" alignItems="center">
              <View style={{ flex: 1, paddingVertical: 10 }}>
                <HStack space="2" alignItems="center">
                  {/* === FullName === */}
                  <Text style={{ fontSize: 12 }}>
                    {this.props.model.fullName}
                  </Text>
                  {this.props.model.topLevel === ROLE_NONE && (
                    <Text style={{ fontSize: 8, color: Theme.COLORS.MUTED }}>
                      ({translate(`user.role.${this.props.model.topLevel}`)})
                    </Text>
                  )}
                  {/* === PhoneNumber === */}
                  {this.props.model.phoneNumber && (
                    <Text style={[styles.subTitle]}>
                      {"(" +
                        hidePhoneNumber(this.props.model.phoneNumber) +
                        ")"}
                    </Text>
                  )}
                </HStack>
                {/* === expire Seconds === */}
                {this.state.expireSeconds > 0 && (
                  <Countdown
                    style={{ justifyContent: "flex-start" }}
                    // until={this.state.expireSeconds}
                    until={2000}
                    size={8}
                    digitStyle={{ backgroundColor: "#FFFFFF00" }}
                    timeLabelStyle={{ color: Theme.COLORS.MUTED }}
                    timeLabels={{
                      d: translate("timer.days"),
                      h: translate("timer.hours"),
                      m: translate("timer.minutes"),
                      s: translate("timer.seconds"),
                    }}
                    showSeparator
                  />
                )}
                {/* <Text style={styles.subTitle}>{this.props.model.description}</Text> */}
              </View>
              <HStack space="2">
                <FontAwesomeIcon
                  icon={getIsRTL() ? faArrowLeft : faArrowRight}
                  size={16}
                  style={{ marginHorizontal: 10 }}
                  color={Theme.COLORS.MUTED}
                />
              </HStack>
            </HStack>
          </HStack>
        </TouchableHighlight>
        {this.state.showDeleteModal && (
          <ModalBase
            isOpen={this.state.showDeleteModal}
            onClose={this.hideDeleteModal}
            // contentStyle={{ height: 140 }}
          >
            <View style={styles.modalInsideWrapper}>
              <Text style={{ marginBottom: 20 }}>
                {translate("user.userWillRemove")}
              </Text>
              <HStack space="2" w="100%">
                <ArButton
                  color="error"
                  style={{ flex: 1, marginBottom: 0 }}
                  onPress={() => this.handleDeleteUser(this.props.model.id)}
                >
                  {translate("user.deleteUser")}
                </ArButton>
                <ArButton
                  variant="outline"
                  color="muted"
                  style={{ flex: 1, marginBottom: 0 }}
                  onPress={this.hideDeleteModal}
                >
                  {translate("app.cancel")}
                </ArButton>
              </HStack>
            </View>
          </ModalBase>
        )}
      </>
    );
  }
}
const RenderMenuItem = (props) => {
  if (Platform.OS === "web") {
    return (
      <HStack
        space="1.5"
        flexDirection="row-reverse"
        justifyContent="flex-end"
        style={{ width: "100%" }}
      >
        <Text style={styles.menuTextStyle}>{props.children}</Text>
        {props?.icon && (
          <FontAwesomeIcon
            icon={props.icon}
            size={14}
            color={props.iconColor || Theme.COLORS.BLACK}
          />
        )}
      </HStack>
    );
  }
  return <Text style={styles.menuTextStyle}>{props.children}</Text>;
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 5,
  },
  userItemsWrapper: {
    justifyContent: "center",
    marginBottom: 5,
    height: 65,
    borderRadius: 5,
    backgroundColor: Theme.COLORS.WHITE,

    shadowColor: Theme.COLORS.INPUT,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
    direction: getDir(),
  },
  badge: {
    backgroundColor: "red",
    minWidth: 16,
    height: 16,
    borderRadius: 8,
    fontSize: 8,
    color: "#fff",
    textAlign: "center",
    textAlignVertical: "center",
  },
  heading: {
    fontWeight: "bold",
    fontSize: 28,
    padding: 12,
    textAlign: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
  },
  btnAdd: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: Theme.COLORS.PRIMARY,
    position: "absolute",
    bottom: 15,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  subTitle: {
    color: Theme.COLORS.MUTED,
    fontSize: 10,
  },
  modalInsideWrapper: {
    width: "100%",
    padding: 10,
    borderRadius: 15,
    alignItems: "center",
    alignSelf: "center",
  },
  modalInsideItemWrapper: {
    flexDirection: IS_WEB ? "row-reverse" : "row",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
  },
  userModalButton: {
    width: "100%",
    marginVertical: 8,
    padding: 10,
    borderRadius: 5,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  userModalButtonText: {
    color: Theme.COLORS.WHITE,
    paddingHorizontal: 5,
    flex: 1,
    textAlign: "center",
    fontSize: 14,
  },
  userModalButtonIcon: {
    marginHorizontal: 10,
    width: "10%",
  },
  iconRoleContainer: {
    justifyContent: "center",
    alignItems: "center",
    width: 50,
    height: 50,
    borderRadius: 28,

    shadowColor: Theme.COLORS.INPUT,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
  roleText: {
    width: "100%",
    textAlign: "center",
    fontSize: 8,
    color: Theme.COLORS.MUTED,
  },
  btn: {
    width: 45,
    height: 45,
    borderRadius: 10,
  },
  btnAccess: {
    borderColor: "#80234845",
    borderWidth: 1,
    shadowColor: "#80234845",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
  btnDelete: {
    backgroundColor: "#fee6eb",
    shadowColor: Theme.COLORS.INPUT,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
  menuTextStyle: {
    textAlign: "right",
    fontSize: 12,
  },
  menuShadow: {
    padding: 5,
    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.UserReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAll: (search, accessToken) =>
      dispatch(Actions.GetAll(search, accessToken)),
    RemoveUser: (userId, accessToken) =>
      dispatch(Actions.RemoveUser(userId, accessToken)),
    RemoveErrorLocally: () => dispatch(Actions.RemoveErrorLocally()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserListScreen);
